import { useContext, useState } from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import {
  Checkbox,
  Collapse,
  Divider,
} from "@mui/material";
import { MainThemeContext } from "../context/ThemeProvider/ThemeProvider";
import { CalendarMonth, ExpandLess, ExpandMore } from "@mui/icons-material";
function SettingsComponent() {
  const [open, setOpen] = useState<"date-format" | "">("");
  const { customTheme, setCustomTheme } = useContext(MainThemeContext);
  const handleDateFormat = (
    dateFormat: "DD-MM-YYYY" | "YYYY-MM-DD" | "MM-DD-YYYY"
  ) => {
    const updated = {
      ...customTheme,
      dateFormat,
    };
    setCustomTheme(updated);
  };
  const handleOpen = (openCollapse: "date-format" | "") => {
    if (open == "") {
      setOpen(openCollapse);
    } else {
      setOpen("");
    }
  };

  return (
    <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
      <List>
        <ListItem disablePadding>
          <ListItemButton
            onClick={() => {
              handleOpen("date-format");
            }}
          >
            <ListItemIcon>
              <CalendarMonth />
            </ListItemIcon>
            <ListItemText primary="Date format" />
            {open == "date-format" ? <ExpandLess /> : <ExpandMore />}
          </ListItemButton>
        </ListItem>
        <Collapse in={open == "date-format"} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItemButton
              sx={{ pl: 4 }}
              onClick={() => {
                handleDateFormat("DD-MM-YYYY");
              }}
            >
              <ListItemIcon>
                <Checkbox checked={customTheme.dateFormat == "DD-MM-YYYY"} />
              </ListItemIcon>
              <ListItemText primary="DD-MM-YYYY" />
            </ListItemButton>
            <ListItemButton
              sx={{ pl: 4 }}
              onClick={() => {
                handleDateFormat("YYYY-MM-DD");
              }}
            >
              <ListItemIcon>
                <Checkbox checked={customTheme.dateFormat == "YYYY-MM-DD"} />
              </ListItemIcon>
              <ListItemText primary="YYYY-MM-DD" />
            </ListItemButton>
            <ListItemButton
              sx={{ pl: 4 }}
              onClick={() => {
                handleDateFormat("MM-DD-YYYY");
              }}
            >
              <ListItemIcon>
                <Checkbox checked={customTheme.dateFormat == "MM-DD-YYYY"} />
              </ListItemIcon>
              <ListItemText primary="MM-DD-YYYY" />
            </ListItemButton>
          </List>
        </Collapse>
        <Divider />
        <ListItem disablePadding>

        </ListItem>
      </List>
    </Box>
  );
}

export default SettingsComponent;
